import React, { memo as Memo, useMemo } from 'react'
import { withDataContext, withUIContext } from 'context'

//* Component
import { Page, GlobalInfoPopup } from 'components/common'
import { HeroSectionAbout, ImgTextComp, MuseumStats, Slider, Host, Guests, Publications, Partners } from 'components/pages'

const AboutMuseum = Memo(({ pages, selectedLang, pageParams, winWidth }) => {

    //! Page Data
    const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])

    return (
        <Page className='about-msm' meta={pageData?.content.meta}>
            {
                pageData ?
                    <>
                        {
                            winWidth >= 1024 ?
                                <GlobalInfoPopup />
                                : ''
                        }
                        <HeroSectionAbout data={pageData.content.heroSectionData} />
                        <ImgTextComp image={pageData.content.section2Data.image} data={pageData.content.section2Data} />
                        <MuseumStats
                            src={pageData.content.museumStatsData.image}
                            data={pageData.content.museumStatsData}
                        />
                        <Slider data={pageData.content.section5Photos} />
                        <ImgTextComp
                            landscapeImg={true}
                            image={pageData.content.section6Image}
                            data={pageData.content.section6Data}
                        />
                        <Host hostContent={pageData.content.section7Text} />
                        <Guests data={pageData.content.section8Photos} />
                        <Publications title={'ourPublishments'} data={pageData.publishments} />
                        <Partners
                            data={pageData.partners}
                            title={'ourPartners'}
                            genPartnerLogo={pageData.content.partner.logo}
                            genPartnerTitle={'“Art support”'}
                            genPartnerDescription={pageData.content.partner.description}
                        />
                    </>
                    : null
            }
        </Page>
    )
})

export default withUIContext(withDataContext(AboutMuseum,
    ['pages']),
    ['winWidth'])